<template>
  <div class="comfooter">
    <div class="footer_top">
      <div class="mainWidth">
        <mu-row class="ftop_box">
          <mu-col  width="33" tablet="33" desktop="33" class="ftop_title">
            {{$t('comfooter.title')}}
          </mu-col>
          <mu-col  width="66" tablet="66" desktop="66" class="ftop_link">
            <span class="link_name">{{$t('comfooter.linksite.name')}}</span>：<span class="site" v-for="item in $t('comfooter.linksite.link')" @click="routeTo(item.url)">{{item.name}}</span>
          </mu-col>

        </mu-row>
        <mu-row gutter class="ftop_context">
          <mu-col width="33" tablet="33" desktop="33">
            <p v-for="i in 4" class="cxt_info">
              {{$t('comfooter.contextInfo')[i-1]}}
              </p>
          </mu-col>
          <mu-col width="33" tablet="33" desktop="33">
            <p v-for="i in 4" class="cxt_info">
              {{$t('comfooter.contextInfo')[i+3]}}
              </p>
          </mu-col>
          <mu-col width="33" tablet="33" desktop="33" class="ewm">
            <div class="ewm_box">
              <img class="ewm_image" :src="$t('comfooter.ewm[0].url')"/>
              <div class="ewm_intro">{{$t('comfooter.ewm[0].intro')}}</div>
            </div>
            <div class="ewm_box">
              <img class="ewm_image" :src="$t('comfooter.ewm[1].url')" />
              <div class="ewm_intro">{{$t('comfooter.ewm[1].intro')}}</div>
            </div>
          </mu-col>
        </mu-row>
      </div>


    </div>
    <div class="footer_bottom">
      <div class="mainWidth">
        <div class="footer_logo"></div>
        <div class="copyright">Copyright © Suooter All Rights Reserved. 速得尔科技（北京）有限公司 版权所有</div>
        <div class="icp"><a href="https://beian.miit.gov.cn">京ICP备14000951-1号</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comfooter',
  data () {
    return {

    }
  },
  methods:{
    routeTo(url){
        window.open(url,'_blank');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .comfooter{
    color:#fff;
    .footer_top{
      width:100%;
      height:330px;
      background:#2095D4;
      .ftop_box{
        padding:46px 0px;
        .ftop_title{
          color:#fff;
          font-size:24px;
          float:left;
        }
        .ftop_link{
          color:#fff;
          float:left;
          line-height:36px;
          font-size:14px;
          border-bottom:1px solid #ccc;
          transform:translateY(20px);
          .site{
            padding:0px 10px;
            transition: all 500ms;
            cursor:pointer;
            font-size:14px;
            &:hover{

            }
          }
        }
      }
      .cxt_info,.ewm_intro{
        line-height:20px;
        margin:8px 0px;
      }
      .ewm_box{
        float:left;
        width:120px;
        text-align:center;
        >img{
          margin:0 auto;
        }

      }
      .ewm_box:nth-last-child(1){
        margin-left:70px;
      }
      .ewm_image{
        width:100px;
        height:100px;
      }
    }
    .footer_bottom{
      width:100%;
      border-top:1px solid #5a5a5a;
      height:50px;
      .mainWidth>div{
        float:left;
        font-size:12px;
        color: #5a5a5a;
        height:50px;
        line-height:52px;
      }
      .footer_logo{
        width:107px;
        height:50px;
        background:url("../assets/images/suooter-logo.png") no-repeat center center;
        background-size:100% auto;
        float:left;
      }
      .copyright{
       margin:0px 16px;
      }
      .icp{
        a{
          color: #5a5a5a;
          &:hover{
            color:#2095D4;
          }
        }
      }
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/comfooter.vue